import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureExceptionResolve(): boolean {
  return useFeatureEnabled('EXCEPTION_RESOLVE');
}
